import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RelevantStandard } from '../../../models/scoring.model';
import { GriPopupModel } from './gri-popup.model';

@Component({
  selector: 'app-gri-popup',
  templateUrl: './gri-popup.component.html',
  styleUrls: ['./gri-popup.component.scss'],
})
export class GriPopupComponent implements OnInit {
  category!: string;

  relevantStandards: RelevantStandard[] = [];

  sliderPositions: number[] = [];

  maxHeight = '300px';

  constructor(public dialogRef: MatDialogRef<GriPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: GriPopupModel) {}

  ngOnInit(): void {
    this.category = this.data.category;
    this.relevantStandards = this.filterRelevantStandardsByCategory(this.data.relevantStandards, this.category);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private filterRelevantStandardsByCategory(
    relevantStandards: RelevantStandard[],
    category: string,
  ): RelevantStandard[] {
    return relevantStandards.filter((standard) => standard.category.toLowerCase() === category.toLowerCase());
  }
}
